import { render, staticRenderFns } from "./EditUrbans.vue?vue&type=template&id=025290df&"
import script from "./EditUrbans.vue?vue&type=script&lang=js&"
export * from "./EditUrbans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports